import { useEffect, useState } from "react";
import { supabase, supabaseConfigured } from "./supabase";
import { CONTACT } from "./content";

// Public site ayarları: admin panelindeki "Site Ayarları"ndan yönetilir.
// site_settings tablosu henüz yoksa (migration öncesi) varsayılanlar kullanılır.
const DEFAULTS = {
  whatsapp: CONTACT.whatsapp,
  phone: CONTACT.phone,
  email: CONTACT.email,
  address: CONTACT.address,
  hours: CONTACT.hours,
  instagram: "https://www.instagram.com/viaprimeluxury/",
  hero_label: "İstanbul'un Prestij Markası",
  hero_subline:
    "Kurumsal filonuz için sıfır bakım riski, vergi avantajı ve 7/24 kesintisiz destek — 2026 model sıfır kilometre premium sedanlarla.",
};

let cache = null;

export async function getSettings() {
  if (cache) return cache;
  const settings = { ...DEFAULTS };
  if (supabaseConfigured) {
    try {
      const { data, error } = await supabase.from("site_settings").select("key, value");
      if (!error && data) {
        data.forEach((row) => {
          if (row.key in settings) settings[row.key] = row.value;
        });
      }
    } catch {
      /* tablo henüz yok — varsayılanlarla devam */
    }
  }
  cache = settings;
  return settings;
}

export function useSettings() {
  const [settings, setSettings] = useState(DEFAULTS);
  useEffect(() => {
    getSettings().then(setSettings);
  }, []);
  return settings;
}

// Admin ayarları kaydettiğinde önbelleği tazelemek için
export function invalidateSettingsCache() {
  cache = null;
}
